var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedRadio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#328734"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17037_21567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6747 9.28809C20.2415 8.85435 19.5381 8.85463 19.1044 9.28809L12.037 16.3558L8.89587 13.2146C8.46213 12.7809 7.75904 12.7809 7.3253 13.2146C6.89157 13.6484 6.89157 14.3515 7.3253 14.7852L11.2516 18.7115C11.4683 18.9282 11.7525 19.0368 12.0367 19.0368C12.3209 19.0368 12.6054 18.9285 12.8221 18.7115L20.6747 10.8586C21.1084 10.4252 21.1084 9.7218 20.6747 9.28809Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17037_21567"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedRadio);
export default __webpack_public_path__ + "static/media/CheckedRadio.2733a3e928d6da3c63c647a57dbef05f.svg";
export { ForwardRef as ReactComponent };